export default __webpack_public_path__ + "static/media/post_front.7efcb7b2.pdf";